import React, { createContext, useContext, useState, ReactNode } from 'react';
import { IParameter } from '@/modules/gpt-chats/types/tools.service.type';

interface CreateApiFormData {
  actionId?: string;
  name: string;
  description: string;
  method: string;
  endpoint: string;
  input_parameters: Record<string, IParameter>;
  output_parameters: Record<string, IParameter>;
}

interface CreateApiContextType {
  formData: CreateApiFormData;
  updateFormData: (data: Partial<CreateApiFormData>) => void;
  resetFormData: () => void;
  setFormData: (data: CreateApiFormData) => void;
}

const defaultFormData: CreateApiFormData = {
  actionId: undefined,
  name: '',
  description: '',
  method: 'GET',
  endpoint: '',
  input_parameters: {},
  output_parameters: {},
};

const CreateApiContext = createContext<CreateApiContextType | undefined>(undefined);

export const CreateApiProvider = ({ children }: { children: ReactNode }) => {
  const [formData, setFormData] = useState<CreateApiFormData>(defaultFormData);

  const updateFormData = (data: Partial<CreateApiFormData>) => {
    setFormData((prev) => ({ ...prev, ...data }));
  };

  const resetFormData = () => {
    setFormData(defaultFormData);
  };

  const setCompleteFormData = (data: CreateApiFormData) => {
    setFormData(data);
  };

  return (
    <CreateApiContext.Provider
      value={{ formData, updateFormData, resetFormData, setFormData: setCompleteFormData }}
    >
      {children}
    </CreateApiContext.Provider>
  );
};

export const useCreateApiContext = () => {
  const context = useContext(CreateApiContext);
  if (!context) {
    throw new Error('useCreateApiContext must be used within CreateApiProvider');
  }
  return context;
};
